<template>
    <!-- Footer -->
    <footer id="page-footer" class="bg-body-light">
        <div class="content py-0">
            <div class="row font-size-sm">
                <div class="col-sm-6 order-sm-1 text-center text-sm-left">
                    <a class="font-w600" href="#" target="_blank">{{config.app.name}}</a> &copy; <span
                        data-toggle="year-copy">2018</span>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
       computed: {
           config(){
               return {
                   app: {
                       name: 'Roamtech Cloud'
                   }
               }
           }
       },
        mounted(){

        }
    }
</script>
